import { combineReducers } from "redux";

// Feature slices - new locations
import auth from "../../features/auth/slices/auth.slice";
import notification from "../../features/notifications/slices/notification.slice";
import account from "../../features/accounts/slices/account.slice";
import facility from "../../features/facilities/slices/facility.slice";
import permission from "../../features/auth/slices/permission.slice";
import hospital from "../../features/hospital/slices/hospital.slice";
import admission from "../../features/admissions/slices/admission.slice";
import communityTransfer from "../../features/community-transfer/slices/community-transfer.slice";
import deceased from "../../features/deceased/slices/deceased.slice";
import overall from "../../features/overall/slices/overall.slice";
import activeFacilities from "../../features/facilities/slices/activeFacilities.slice";
import common from "../../features/common/slices/common.slice";
import customCard from "../../features/common/slices/customCard.slice";
import dataCardsExpand from "../../features/common/slices/dataCardsExpand.slice";
import uiReducer from "../../features/ui/slices/ui.slice";

// Comparison slices
import comparison from "../../features/comparison/slices/comparison.slice";
import hospitalComparison from "../../features/hospital/slices/hospitalComparison.slice";
import admissionComparison from "../../features/admissions/slices/admissionComparison.slice";
import communityTransferComparison from "../../features/community-transfer/slices/communityTransferComparison.slice";
import deceasedComparison from "../../features/deceased/slices/deceasedComparison.slice";
import overallComparison from "../../features/overall/slices/overallComparison.slice";

// Note service (keep temporarily until migrated to RTK Query)
import noteReducer from "../../services/note.service";

// API slice
import { apiSlice } from "../api/apiSlice";

// Legacy permissions reducer - now merged into permission slice
// Keeping 'permissions' key for backward compatibility during migration
// Components using state.permissions should migrate to state.permission.userPermissions

const rootReducer = combineReducers({
  // Core slices
  customCard,
  auth,
  notification,
  account,
  facility,

  // Domain slices
  hospital,
  hospitalComparison,
  admissionComparison,
  communityTransferComparison,
  deceasedComparison,
  overallComparison,

  // Permission slices
  // Keep 'permissions' for backward compatibility (maps to permission.userPermissions)
  permissions: (state = ["DELETE"], action) => {
    if (action.type === "permission/setUserPermissions") {
      return action.payload;
    }
    return state;
  },
  permission,

  // Main domain slices
  admission,
  communityTransfer,
  deceased,
  overall,

  // UI and common slices
  dataCardsExpand,
  activeFacilities,
  comparison,
  common,
  note: noteReducer,
  ui: uiReducer,

  // RTK Query API
  [apiSlice.reducerPath]: apiSlice.reducer,
});

export default rootReducer;
